/**
 * @generated SignedSource<<665d02af1da71bbfd4e8b40eb5b22f55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserInfo_authUser$data = {
  readonly actor: {
    readonly " $fragmentSpreads": FragmentRefs<"AvatarIcon_actor">;
  } | null;
  readonly " $fragmentType": "UserInfo_authUser";
};
export type UserInfo_authUser$key = {
  readonly " $data"?: UserInfo_authUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserInfo_authUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserInfo_authUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AvatarIcon_actor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "1f6adf84311ab313320fe0383e901f39";

export default node;
